export default __webpack_public_path__ + "static/media/buy-icon.9b0f8540.svg";